<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>
<main class="gs">
  <header class="gs--header">
    <div class="gs--header__container">
      <h5 class="gs--header__title">
        {{ 'newRequestGS' | i18next }}
      </h5>
      <div id="stepperHeader"></div>
    </div>
  </header>
  <app-stepper
    [user]="user"
    [requestType]="requestType"
    [steps]="steps"
    (sendRequestEmitter)="sendRequest($event)"
  ></app-stepper>
</main>
